import {Component, EventEmitter, OnInit} from '@angular/core';
import {ColorService} from '../../../app-common/services/color/color.service';
import {TenantService} from '../../services/tenant/tenant.service';
import {TenantDto} from '../../data/tenantDto';
import {AuthService} from '../../services/auth/auth.service';
import {Router} from '@angular/router';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';
import {LogLevel} from '../../../logging/data/logLevel';
import {AppService} from "../../../app-common/services/app/app.service";

@Component({
  selector: 'app-tenant-selection-page',
  templateUrl: './tenant-selection-page.component.html',
  styleUrls: ['./tenant-selection-page.component.scss']
})
export class TenantSelectionPageComponent implements OnInit {

  tenants: TenantDto[];
  noOrganizations: boolean = false;
  displayCreateOrganizationDialogEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(public colorService: ColorService,
              private tenantService: TenantService,
              private authService: AuthService,
              private router: Router,
              private loggerService: LoggerService,
              private appService: AppService) {
  }

  ngOnInit(): void {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.TenantSelectionPage, 'Navigated to tenant selection page, fetching organizations');
    try {
      this.tenantService.getMyOrganizations().then(organizations => {
        if (organizations){
          this.tenants = organizations;
          if (organizations.length === 1) {
            this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.TenantSelectionPage, 'Only one organization, connecting to it');
            this.connectToOrganization(organizations[0]);
          }
          if (organizations.length === 0) {
            this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.TenantSelectionPage, 'No organizations');
            this.noOrganizations = true;
          }
        } else {
          this.appService.showErrorMessage('Failed to get organizations, Please try again.');
          this.logout();
        }
      });
    } catch {
      this.loggerService.logMessage(LogLevel.ERROR, LogSourceType.COMPONENT, LogSource.TitleBarComponent, 'Failed to get organizations');
      this.appService.showErrorMessage('Failed to get organizations, Please try again.');
      this.logout();
    }
  }

  logout(): void {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.TenantSelectionPage, 'Clicked logout button');
    this.authService.logout();
    this.router.navigate(['login']);
  }

  async connectToOrganization(organization: TenantDto) {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.TenantSelectionPage, 'Clicked connect to organization button');
    await this.tenantService.connectToTenant(organization).then(() => {
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.TenantSelectionPage, 'Connected to organization, navigating to home page');
      this.router.navigate(['home']);
    });
  }

  refreshTenants() {
    this.ngOnInit();
  }
}
